import type { LucideIcon } from "lucide-react";
import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";
import type { ReactNode } from "react";

export function MetricCard({
  label,
  value,
  hint,
  icon: Icon,
  tone = "violet",
  trend,
  footer,
}: {
  label: string;
  value: string;
  hint?: string;
  icon: LucideIcon;
  tone?: "violet" | "emerald" | "blue" | "amber" | "coral" | "cyan";
  trend?: number | null;
  footer?: ReactNode;
}) {
  return (
    <article className="metric-card">
      <div className={`metric-icon metric-icon--${tone}`}>
        <Icon size={19} />
      </div>
      <div className="metric-copy">
        <span>{label}</span>
        <strong>{value}</strong>
        {hint ? <small>{hint}</small> : null}
      </div>
      {trend !== undefined ? (
        <div
          className={`metric-trend ${trend === null || trend === 0 ? "metric-trend--flat" : trend > 0 ? "metric-trend--up" : "metric-trend--down"}`}
        >
          {trend === null || trend === 0 ? (
            <Minus size={14} />
          ) : trend > 0 ? (
            <ArrowUpRight size={14} />
          ) : (
            <ArrowDownRight size={14} />
          )}
          {trend === null ? "sem base" : `${Math.abs(trend).toFixed(1)}%`}
        </div>
      ) : null}
      {footer ? <div className="metric-footer">{footer}</div> : null}
    </article>
  );
}
